import React from "react";
import Grid from '@mui/material/Grid';
import { Outlet } from 'react-router-dom';
import { Typography } from '@mui/material';

import { PATHS } from "../type/EnumPaths";
import BrandList from "../component/BrandList";
import AllHashtags from "../component/AllHashtags";
import TwoColumnLayout from "./TwoColumn";
import MainLayout from "./MainLayout";

export const ProductLayout = () => {
  return (
    <MainLayout>
      <TwoColumnLayout
        header={
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ paddingTop: "0px" }}>
              <Typography
                component="h2"
                variant="h5"
                color="#FFFFFF"
              >
                Do not see what you need? Contact us.
              </Typography>
            </Grid>
            <Grid item xs={6} sx={{ sm: { maxHeight: "50vh", overflow: "scroll" } }}>
              <AllHashtags page={PATHS.PRODUCTS} />
            </Grid>
            <Grid item xs={6}>
              <BrandList />
            </Grid>
          </Grid>
        }
      >
        <Outlet />
      </TwoColumnLayout>
    </MainLayout>
  )
}